module.exports = __webpack_public_path__ + "img/util-tab-3-title.b158907e.svg";